module.exports = __webpack_public_path__ + "static/media/eye_logo_on.25411b8d.svg";